var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-toast',{attrs:{"header":"Server Error","message":"Your Registration could not be processed! Please try again later"}})}
var staticRenderFns = []

export { render, staticRenderFns }